import RushAverage from '@/assets/icons/RushAverage';
import RushBusy from '@/assets/icons/RushBusy';
import RushCalm from '@/assets/icons/RushCalm';
import RushOvercrowded from '@/assets/icons/RushOvercrowded';
import { gekoppeldeInzet } from '@/components/detailPanel/types/types';

export function getRushIcon(
  prognose?: number,
  comfortabelNorm?: number,
  acceptabelNorm?: number,
  gekoppeldeInzetten?: gekoppeldeInzet[],
) {
  const isManco = (inzet: gekoppeldeInzet) => inzet.eenheid?.nummer === 'MANCO';

  let totalComfortabelNorm = comfortabelNorm ?? 0;
  let totalAcceptableNorm = acceptabelNorm ?? 0;

  // Voeg comfortabeleNorm van gekoppeldeInzetten toe als die er zijn
  // Exclude 'MANCO' from the zitplaatsen sum
  totalComfortabelNorm += (gekoppeldeInzetten ?? []).reduce((sum: number, inzet) => {
    const norm = inzet.treinSamenstelling?.comfortabelNorm;
    return isManco(inzet) || typeof norm !== 'number' ? sum : sum + norm;
  }, 0);

  totalAcceptableNorm += (gekoppeldeInzetten ?? []).reduce((sum: number, inzet) => {
    const norm = inzet.treinSamenstelling?.acceptabelNorm;
    return isManco(inzet) || typeof norm !== 'number' ? sum : sum + norm;
  }, 0);

  if (!totalComfortabelNorm || !prognose) return null;

  const iconStyles = { width: 16, height: 16 };

  // < 50% van comfortabelNorm: 1 groen
  if (prognose < totalComfortabelNorm * 0.5)
    return <RushCalm style={{ ...iconStyles, fill: 'var(--tractie-color-content-success)' }} />;
  // 50-100% van comfortabelNorm: 2 oranje
  if (prognose <= totalComfortabelNorm)
    return <RushAverage style={{ ...iconStyles, fill: 'var(--tractie-color-content-warning)' }} />;
  // > comfortabelNorm && <= acceptabelNorm: 3 rood
  if (totalAcceptableNorm && prognose <= totalAcceptableNorm)
    return <RushBusy style={{ ...iconStyles, fill: 'var(--tractie-color-content-error)' }} />;
  // > acceptabelNorm: 3 met kruisje rood
  return <RushOvercrowded style={{ ...iconStyles, fill: 'var(--tractie-color-content-error)' }} />;
}
